import React from 'react';
import Styles from './styles.module.scss';

const LoadingSpinner: React.FC = () => {
  return (
    <div className={Styles.spinner}>
      <div className={Styles.spinner__circle}></div>
    </div>
  );
};

export default LoadingSpinner;
